"use client";

import { memo } from "react";
import { Box, HStack, VStack, Text } from "@chakra-ui/react";
import type { AtsJobDetails } from "../types";
import { SectionTitle } from "./SectionTitle";

export interface CertificatesSectionProps {
  certificates?: AtsJobDetails["certificates"];
}

export const CertificatesSection = memo<CertificatesSectionProps>(
  ({ certificates }) => {
    if (!certificates || certificates.length === 0) return null;

    return (
      <Box as="section" aria-label="Certificates" mb={6}>
        <SectionTitle title="Certificates" />
        <VStack align="stretch" gap={2}>
          {certificates.map((cert, index) => {
            const issuedYear = cert.date
              ? new Date(cert.date).getFullYear()
              : "";
            return (
              <HStack
                key={`${cert.name}-${index}`}
                justify="space-between"
                align="flex-start"
                wrap="wrap"
              >
                <Text
                  textStyle="sm"
                  fontWeight="bold"
                  color="neutral.900"
                  lineHeight="1.5"
                  flex={1}
                >
                  {cert.name}
                </Text>
                {issuedYear ? (
                  <Text
                    textStyle="sm"
                    color="neutral.500"
                    whiteSpace="nowrap"
                    textAlign="right"
                  >
                    {issuedYear}
                  </Text>
                ) : null}
              </HStack>
            );
          })}
        </VStack>
      </Box>
    );
  },
);
CertificatesSection.displayName = "CertificatesSection";
